export default __webpack_public_path__ + "static/media/utako-terminal.928e4790.png";